import { _ as _objectSpread2 } from '../../_rollupPluginBabelHelpers-a38db067.js';

function get(obj, path, fallback) {
  const key = typeof path === 'string' ? path.split('.') : [path];
  let result = obj;
  for (let i = 0; i < key.length; i += 1) {
    if (!result) {
      break;
    }
    result = result[key[i]];
  }
  return result === undefined ? fallback : result;
}
function merge(a, b) {
  const result = _objectSpread2(_objectSpread2({}, a), b);
  Object.keys(result).forEach(key => {
    if (!a[key] || typeof b[key] !== 'object') {
      return;
    }
    Object.assign(result, {
      [key]: Object.assign(a[key], b[key])
    });
  });
  return result;
}
function sort(obj) {
  const result = {};
  Object.keys(obj).sort((a, b) => a.localeCompare(b, undefined, {
    numeric: true,
    sensitivity: 'base'
  })).forEach(key => {
    result[key] = obj[key];
  });
  return result;
}

export { get, merge, sort };
